import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { isAppRoute } from 'routes/paths'
import Badge from 'components/Badge'

import {
  Wrapper,
  Article,
  Content,
  AdImage,
  HeaderWrapper,
  BodyWrapper,
  BrandIcon,
  BadgeWrapper,
  SubjectWrapper,
  Title,
  SponsoredByWrapper,
  BodyText,
} from './StyledNativeAd'

class NativeAd extends Component {
  componentDidMount() {
    const { ad: { impressionTrackers = [] } = {} } = this.props
    this.callTrackers(impressionTrackers)
  }

  callTrackers = (trackers = []) => {
    trackers.forEach((tracker) => {
      const request = new XMLHttpRequest()
      request.open('GET', tracker)
      request.send()
    })
  }

  render() {
    const {
      ad: { title, sponsoredBy, body, clickTrackers, clickUrl, icon, desc2, image },
      id,
      device,
      baseUrl,
    } = this.props

    const ismobile = !device.is('medium')

    let imageUrl
    let iconUrl
    const badgeText = 'Reklam'

    switch (desc2) {
      case 'lokalpaketet_basic':
        imageUrl = _.get(image, 'url')
        iconUrl = _.get(icon, 'url')
        break

      case 'native_ad_basic':
        imageUrl = _.get(image, 'url')
        iconUrl = null
        break

      default:
        imageUrl = _.get(icon, 'url')
        iconUrl = null
        break
    }

    const domain = (url) => url.replace(/(http|https):\/\//, '').split('/')[0]
    const externalDomain = (url) => domain(url).length > 0 && domain(baseUrl) !== domain(url)
    const external = externalDomain(clickUrl) && !isAppRoute(clickUrl)
    const callTrackers = () => this.callTrackers(clickTrackers)

    const extraAttr = external
      ? {
          target: '_blank',
          rel: 'nofollow noopener',
        }
      : {}
    return (
      <Wrapper
        key={id}
        to={clickUrl}
        external={external}
        onClick={callTrackers}
        aria-label={title}
        {...extraAttr}
      >
        <Article>
          <AdImage
            width={ismobile ? 135 : 203}
            height={ismobile ? 90 : 135}
            src={imageUrl}
            alt={title}
          />

          <Content>
            <HeaderWrapper ismobile={ismobile ? 1 : 0}>
              <BadgeWrapper>
                <Badge badgeText={badgeText} />
              </BadgeWrapper>
              {sponsoredBy && (
                <SponsoredByWrapper>
                  <span>{sponsoredBy} </span>
                </SponsoredByWrapper>
              )}
            </HeaderWrapper>

            {title && (
              <SubjectWrapper>
                <Title ismobile={ismobile} tagName="h2" style={{ lineHeight: '20px' }}>
                  {title}
                </Title>
              </SubjectWrapper>
            )}

            {body && (
              <BodyWrapper>
                <BodyText ismobile={ismobile ? 1 : 0}>{body}</BodyText>
              </BodyWrapper>
            )}
            {iconUrl && (
              <BrandIcon>
                <AdImage
                  ismobile={ismobile}
                  src={iconUrl}
                  alt="brand logo"
                  width={ismobile ? 87 : 130}
                  height={ismobile ? 25 : 60}
                />
              </BrandIcon>
            )}
          </Content>
        </Article>
      </Wrapper>
    )
  }
}

NativeAd.propTypes = {
  id: PropTypes.string,
  ad: PropTypes.object.isRequired,
  device: PropTypes.object,
  baseUrl: PropTypes.string,
}

const mapStateToProps = (state) => ({
  baseUrl: state.config.urls.base,
})

export default connect(mapStateToProps)(NativeAd)
